export const LOGIN = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT: "LOGOUT",
  UPDATE_TOKEN: "UPDATE_TOKEN",
  UPDATE_SELECTED_COMPANY: "UPDATE_SELECTED_COMPANY",
  CLEAN_ERROR: "CLEAN_ERROR",
  VALIDATE_AUTH_REQUEST: "VALIDATE_AUTH_REQUEST",
  VALIDATE_AUTH_SUCCESS: "VALIDATE_AUTH_SUCCESS",
  VALIDATE_AUTH_FAILURE: "VALIDATE_AUTH_FAILURE",
};

export const USER = {
  SET_USER: "SET_USER",
  CLEAN_USER: "CLEAN_USER",
  GET_USERS: "GET_USERS",
  GET_USERS_FAILURE: "GET_USERS_FAILURE",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  UPDATE_USER: "UPDATE_USER",
  UPDATE_USER_FAILURE: "UPDATE_USER_FAILURE",
  UPDATE_USER_SUCCESS: "UPDATE_USER_SUCCESS",
  RESET_PASSWORD: "RESET_PASSWORD",
  RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
  RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
  DEFINE_PASSWORD: "DEFINE_PASSWORD",
  DEFINE_PASSWORD_FAILURE: "DEFINE_PASSWORD_FAILURE",
  DEFINE_PASSWORD_SUCCESS: "DEFINE_PASSWORD_SUCCESS",
  CLEAN_ERROR: "CLEAN_ERROR",
  RESET: "RESET",
};

export const GIFT = {
  CREATE_GIFT: "CREATE_GIFT",
  CREATE_GIFT_FAILURE: "CREATE_GIFT_FAILURE",
  CREATE_GIFT_SUCCESS: "CREATE_GIFT_SUCCESS",
  UPDATE_GIFT: "UPDATE_GIFT",
  UPDATE_GIFT_FAILURE: "UPDATE_GIFT_FAILURE",
  UPDATE_GIFT_SUCCESS: "UPDATE_GIFT_SUCCESS",
  GET_GIFTS: "GET_GIFTS",
  GET_GIFTS_FAILURE: "GET_GIFTS_FAILURE",
  GET_GIFTS_SUCCESS: "GET_GIFTS_SUCCESS",
  CLEAN_GIFT: "CLEAN_GIFT",
};

export const COMPANY = {
  CREATE_COMPANY: "CREATE_COMPANY",
  CREATE_COMPANY_FAILURE: "CREATE_COMPANY_FAILURE",
  CREATE_COMPANY_SUCCESS: "CREATE_COMPANY_SUCCESS",
  UPDATE_COMPANY: "UPDATE_COMPANY",
  UPDATE_COMPANY_FAILURE: "UPDATE_COMPANY_FAILURE",
  UPDATE_COMPANY_SUCCESS: "UPDATE_COMPANY_SUCCESS",
  DELETE_COMPANY: "DELETE_COMPANY",
  DELETE_COMPANY_FAILURE: "DELETE_COMPANY_FAILURE",
  DELETE_COMPANY_SUCCESS: "DELETE_COMPANY_SUCCESS",
  GET_COMPANY: "GET_COMPANY",
  GET_COMPANY_FAILURE: "GET_COMPANY_FAILURE",
  GET_COMPANY_SUCCESS: "GET_COMPANY_SUCCESS",
  GET_COMPANIES: "GET_COMPANIES",
  GET_COMPANIES_SUCCESS: "GET_COMPANIES_SUCCESS",
  GET_COMPANIES_FAILURE: "GET_COMPANIES_FAILURE",
  CLEAN_COMPANY: "CLEAN_COMPANY",
};

export const ADDRESS = {
  GET_ADDRESS: "GET_ADDRESS",
  GET_ADDRESS_FAILURE: "GET_ADDRESS_FAILURE",
  GET_ADDRESS_SUCCESS: "GET_ADDRESS_SUCCESS",
  GET_ADDRESSES: "GET_ADDRESSES",
  GET_ADDRESSES_FAILURE: "GET_ADDRESSES_FAILURE",
  GET_ADDRESSES_SUCCESS: "GET_ADDRESSES_SUCCESS",
  DELETE_ADDRESS: "DELETE_ADDRESS",
  DELETE_ADDRESS_FAILURE: "DELETE_ADDRESS_FAILURE",
  DELETE_ADDRESS_SUCCESS: "DELETE_ADDRESS_SUCCESS",
  CREATE_ADDRESS: "CREATE_ADDRESS",
  CREATE_ADDRESS_FAILURE: "CREATE_ADDRESS_FAILURE",
  CREATE_ADDRESS_SUCCESS: "CREATE_ADDRESS_SUCCESS",
  UPDATE_ADDRESS: "UPDATE_ADDRESS",
  UPDATE_ADDRESS_FAILURE: "UPDATE_ADDRESS_FAILURE",
  UPDATE_ADDRESS_SUCCESS: "UPDATE_ADDRESS_SUCCESS",
  CLEAN_ADDRESS: "CLEAN_ADDRESS",
};

export const FEEDBACK = {
  GET_FEEDBACK: "GET_FEEDBACK",
  GET_FEEDBACK_FAILURE: "GET_FEEDBACK_FAILURE",
  GET_FEEDBACK_SUCCESS: "GET_FEEDBACK_SUCCESS",
};

export const ACTIVITY = {
  GET_ACTIVITIES: "GET_ACTIVITIES",
  GET_ACTIVITIES_FAILURE: "GET_ACTIVITIES_FAILURE",
  GET_ACTIVITIES_SUCCESS: "GET_ACTIVITIES_SUCCESS",
  DELETE_ACTIVITY: "DELETE_ACTIVITY",
  DELETE_ACTIVITY_FAILURE: "DELETE_ACTIVITY_FAILURE",
  DELETE_ACTIVITY_SUCCESS: "DELETE_ACTIVITY_SUCCESS",
};

export const STATS = {
  GET_STATS_USER: "GET_STATS_USER",
  GET_STATS_USER_FAILURE: "GET_STATS_USER_FAILURE",
  GET_STATS_USER_SUCCESS: "GET_STATS_USER_SUCCESS",
  GET_STATS_COMPANY: "GET_STATS_COMPANY",
  GET_STATS_COMPANY_FAILURE: "GET_STATS_COMPANY_FAILURE",
  GET_STATS_COMPANY_SUCCESS: "GET_STATS_COMPANY_SUCCESS",
  CLEAN_STATS: "CLEAN_STATS",
};

export const NOTIFICATIONS = {
  CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
  CREATE_NOTIFICATION_FAILURE: "CREATE_NOTIFICATION_FAILURE",
  CREATE_NOTIFICATION_SUCCESS: "CREATE_NOTIFICATION_SUCCESS",
  UPDATE_NOTIFICATION: "UPDATE_NOTIFICATION",
  UPDATE_NOTIFICATION_FAILURE: "UPDATE_NOTIFICATION_FAILURE",
  UPDATE_NOTIFICATION_SUCCESS: "UPDATE_NOTIFICATION_SUCCESS",
  GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
  GET_NOTIFICATIONS_FAILURE: "GET_NOTIFICATIONS_FAILURE",
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  DELETE_NOTIFICATION: "DELETE_NOTIFICATION",
  DELETE_NOTIFICATION_FAILURE: "DELETE_NOTIFICATION_FAILURE",
  DELETE_NOTIFICATION_SUCCESS: "DELETE_NOTIFICATION_SUCCESS",
  CLEAN_NOTIFICATIONS: "CLEAN_NOTIFICATIONS",
  GET_NOTIFICATION: "GET_NOTIFICATION",
  GET_NOTIFICATION_FAILURE: "GET_NOTIFICATION_FAILURE",
  GET_NOTIFICATION_SUCCESS: "GET_NOTIFICATION_SUCCESS",
};

export const AUDIT = {
  GET_AUDIT: "GET_AUDIT",
  GET_AUDIT_FAILURE: "GET_AUDIT_FAILURE",
  GET_AUDIT_SUCCESS: "GET_AUDIT_SUCCESS",
};

export const RATING = {
  GET_RATINGS: "GET_RATINGS",
  GET_RATINGS_FAILURE: "GET_RATINGS_FAILURE",
  GET_RATINGS_SUCCESS: "GET_RATINGS_SUCCESS",
};

export const ALERT = {
  GET_ALERTS: "GET_ALERTS",
  GET_ALERTS_FAILURE: "GET_ALERTS_FAILURE",
  GET_ALERTS_SUCCESS: "GET_ALERTS_SUCCESS",
};

export const VERSION = {
  GET_VERSIONS: "GET_VERSIONS",
  GET_VERSIONS_FAILURE: "GET_VERSIONS_FAILURE",
  GET_VERSIONS_SUCCESS: "GET_VERSIONS_SUCCESS",
};
